import * as moment from 'moment'
import { BaseModel } from '../base.model'
import { OnlineInterviewerSheduleShift } from './online-interviewer-schedule-shift.model'

const day = 24 * 60 * 60 // День в секундах

export class OnlineInterviewerShedulePeriod extends BaseModel<OnlineInterviewerShedulePeriod> {
  static DEFAULT_ATTRIBUTES = {
    size: day,
    beginningAt: moment().utc().startOf('day').unix(),
    order: 0,
    periodType: "default",
    shifts: []
  }
  
  onlineInterviewerScheduleId: number
  name: string
  beginningAt: number
  endingAt: number
  size: number
  order: number
  periodType: string
  state: string
  shifts: OnlineInterviewerSheduleShift[]
  beginningAtDate: Date
  endingAtDate: Date

  constructor(attributes: Object) {
    super(attributes)
    
    if (this.beginningAt) {
      let m = moment.unix(this.beginningAt).utc()
      this.beginningAtDate = new Date(m.year(), m.month(), m.date(), 0, 0, 0)
    }

    if (this.endingAt) {
      // дата окончания отображается на день меньше
      let m = moment.unix(this.endingAt - day).utc()
      this.endingAtDate = new Date(m.year(), m.month(), m.date(), 0, 0, 0)
    }
  }

  /**
   * Извлекает параметры для создания такого же периода
   * @returns Ассоциативный массив параметров
   */
  extract() {
    let shifts = []
    if (this.shifts) {
      this.shifts.forEach(s => {
        shifts.push(OnlineInterviewerSheduleShift.create(s.dayIndex).copyFrom(s))
      })
    }
    return {
      onlineInterviewerScheduleId: this.onlineInterviewerScheduleId,
      beginningAt: this.beginningAt,
      endingAt: this.endingAt,
      size: this.size,
      shifts: shifts
    }
  }

  remove(): void {
    this.state = 'removed'
  }

  
  /**
   * размер периода в днях
   */
  get sizeInDays(): number {
    return this.size / day
  }

  set sizeInDays(daysCount: number) {
    this.size = daysCount * day
  }

  get isRemoved(): boolean {
    return this.state == 'removed'
  }

  get isDisabled(): boolean {
    return this.state == 'disabled'
  }

  get isActive(): boolean {
    return this.state == 'active'
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-interviewer-schedule/online-interviewer-schedule-period.model.ts